import React, { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';

import useWindowSize from '../../../utils/hooks/useWindowSize';

function checkOverflow(el) {
  const elVar = el;

  if (elVar === undefined || elVar === null) return false;

  const curOverflow = elVar.style.overflow;

  if (!curOverflow || curOverflow === 'visible') elVar.style.overflow = 'hidden';
  const isOverflowing =
    elVar.clientWidth < elVar.scrollWidth || elVar.clientHeight < elVar.scrollHeight;

  elVar.style.overflow = curOverflow;

  return isOverflowing;
}

const UnitCardName = ({ className, name }) => {
  const el = useRef(null);

  const [isOverflowing, setIsOverflowing] = useState(false);

  const size = useWindowSize();

  useLayoutEffect(() => {
    const currentElement = el.current;

    // в хроме происходит ререндер компонента хедера айтема в дашборде при выходе из "print" графика.
    // В самом браузере это реализовано через display: none для рута,
    // при этом метрики компонентов становятся нулевыми => пропускаем проверку и установку видимости имени айтема.
    if (currentElement.clientWidth === 0 || currentElement.clientHeight === 0) return;

    setIsOverflowing(checkOverflow(currentElement));
  }, [size, name]);

  return (
    <div ref={el} className={className}>
      {isOverflowing ? (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ) : (
        name
      )}
    </div>
  );
};

export default UnitCardName;
